import React from "react";
import { Link } from "react-router-dom";
import { verifyPermission } from "helpers/permission";
import EmptyTable from "views/components/EmptyTable";
import PeriodBadge from "./PeriodBadge";

const TableRow = ({ rapport, index, plan, userPermissions, onDelete, t }) => {
  const formatStaffNames = (staffs) => {
    if (!staffs) return null;
    return staffs.map(
      (staff, index) =>
        `${staff.identite.firstname} ${staff.identite.lastname}, `
    );
  };

  const formatStaffEmails = (staffs) => {
    if (!staffs) return null;
    return staffs.map((staff, staffIndex) =>
      staff.identite.email
        ? staff.identite.email.map((email, emailIndex) => `${email} `)
        : null
    );
  };

  return (
    <tr key={index} role="row" className="odd">
      {plan === "MACRO" ? (
        <td>
          {rapport.institution_targeted
            ? rapport.institution_targeted.name
            : ""}
        </td>
      ) : null}

      {plan === "PRO" ? <td>{formatStaffNames(rapport.staffs)}</td> : null}

      <PeriodBadge rapport={rapport} t={t} />

      <td>{rapport.reporting_type === null ? "-" : rapport.reporting_type}</td>

      <td>{formatStaffEmails(rapport.staffs)}</td>

      <td style={{ textAlign: "center" }}>
        {verifyPermission(
          userPermissions,
          "update-config-reporting-claim-my-institution"
        ) ? (
          <Link
            to={`/settings/rapport/edit/${rapport.id}`}
            className="btn btn-sm btn-clean btn-icon btn-icon-md"
            title={t("Modifier")}
          >
            <i className="la la-edit" />
          </Link>
        ) : null}

        {verifyPermission(
          userPermissions,
          "delete-config-reporting-claim-my-institution"
        ) ? (
          <button
            onClick={() => onDelete(rapport.id, index)}
            className="btn btn-sm btn-clean btn-icon btn-icon-md"
            title={t("Supprimer")}
          >
            <i className="la la-trash" />
          </button>
        ) : null}
      </td>
    </tr>
  );
};

const TableHeader = ({ plan, t }) => (
  <thead>
    <tr role="row" style={{ textAlign: "center" }}>
      {plan === "MACRO" ? (
        <th
          className="sorting"
          tabIndex="0"
          aria-controls="kt_table_1"
          rowSpan="1"
          colSpan="1"
          style={{ width: "100px" }}
          aria-label="Ship City: activate to sort column ascending"
        >
          {t("Institutions")}
        </th>
      ) : null}

      {plan === "PRO" ? (
        <th
          className="sorting"
          tabIndex="0"
          aria-controls="kt_table_1"
          rowSpan="1"
          colSpan="1"
          style={{ width: "100px" }}
          aria-label="Ship City: activate to sort column ascending"
        >
          {t("Agents")}
        </th>
      ) : null}

      <th
        className="sorting"
        tabIndex="0"
        aria-controls="kt_table_1"
        rowSpan="1"
        colSpan="1"
        style={{ width: "100px" }}
        aria-label="Ship City: activate to sort column ascending"
      >
        {t("Périodes")}
      </th>

      <th
        className="sorting"
        tabIndex="0"
        aria-controls="kt_table_1"
        rowSpan="1"
        colSpan="1"
        style={{ width: "100px" }}
        aria-label="Ship City: activate to sort column ascending"
      >
        {t("Rapports")}
      </th>

      <th
        className="sorting"
        tabIndex="0"
        aria-controls="kt_table_1"
        rowSpan="1"
        colSpan="1"
        style={{ width: "150px" }}
        aria-label="Ship City: activate to sort column ascending"
      >
        Emails
      </th>

      <th
        className="sorting"
        tabIndex="0"
        aria-controls="kt_table_1"
        rowSpan="1"
        colSpan="1"
        style={{ width: "70.25px" }}
        aria-label="Type: activate to sort column ascending"
      >
        {t("Action")}
      </th>
    </tr>
  </thead>
);

const TableFooter = ({ plan, t }) => (
  <tfoot>
    <tr style={{ textAlign: "center" }}>
      {plan === "MACRO" ? (
        <th rowSpan="1" colSpan="1">
          {t("Institutions")}
        </th>
      ) : null}

      {plan === "PRO" ? (
        <th rowSpan="1" colSpan="1">
          {t("Agents")}
        </th>
      ) : null}

      <th rowSpan="1" colSpan="1">
        {t("Périodes")}
      </th>

      <th rowSpan="1" colSpan="1">
        {t("Rapports")}
      </th>

      <th rowSpan="1" colSpan="1">
        {t("Emails")}
      </th>

      <th rowSpan="1" colSpan="1">
        {t("Action")}
      </th>
    </tr>
  </tfoot>
);

const ReportTable = ({
  rapportAuto,
  showList,
  plan,
  userPermissions,
  onDelete,
  t,
}) => {
  return (
    <table
      className="table table-striped- table-bordered table-hover table-checkable dataTable dtr-inline"
      id="myTable"
      role="grid"
      aria-describedby="kt_table_1_info"
      style={{ width: "952px" }}
    >
      <TableHeader plan={plan} t={t} />

      <tbody>
        {rapportAuto.length > 0 ? (
          showList && showList.length > 0 ? (
            showList.map((rapport, index) => (
              <TableRow
                key={index}
                rapport={rapport}
                index={index}
                plan={plan}
                userPermissions={userPermissions}
                onDelete={onDelete}
                t={t}
              />
            ))
          ) : (
            <EmptyTable search={true} />
          )
        ) : (
          <EmptyTable />
        )}
      </tbody>

      <TableFooter plan={plan} t={t} />
    </table>
  );
};

export default ReportTable;
